import React, { useEffect, useState, useRef } from 'react';
import { func, string, bool, number, oneOfType } from 'prop-types';
import { validate as validator } from 'ui-validator';
import { Page } from '../../components';
import validations from './living-status-validations';
import context from '../../serverContext';
import LivingSituation from '../../../repeats-redesign/client/components/LivingSituation/LivingSituation';

const LivingPage = ({
  homeStatus: homeStatusDefaultValue,
  homeStatusExpense: expensesDefaultValue,
  previousLocation,
  nextLocation,
  isJoint,
  saveValues,
  firstName,
  isSecondary,
  isFromSecondLoanFlow,
  isDM,
}) => {
  const [homeStatus, setHomeStatus] = useState(homeStatusDefaultValue);
  let [homeStatusExpense, setHomeStatusExpenses] = useState(expensesDefaultValue);
  const [validationErrors, setValidationErrors] = useState({});
  const pageProps = isSecondary && {
    submitLabel: 'Get Your Rate',
    showSingleDisclaimer: true,
    showDisclaimerContent: true,
  };

  const [form, setForm] = useState({
    validationErrors: {},
    showErrors: false,
  });
  const livingValueRef = useRef();
  const expenseValueRef = useRef();

  const getTitleAndHeader = () => {
    const header = 'Helps us get better sense of your overall expenses.';
    const title = `What's your current living situation?`;
    return {
      title: isJoint ? `${firstName}, ${title.toLocaleLowerCase()}` : title,
      header,
    };
  };

  const onChange = event => {
    livingValueRef.current = event.target.value;
    setHomeStatus(event.target.value);

    setForm(state => ({
      ...state,
      showErrors: false,
    }));
    const errors = validator({ homeStatus }, validations.homeStatus);
    setValidationErrors(errors);
  };

  useEffect(() => {
    livingValueRef.current = homeStatus;
    expenseValueRef.current = homeStatusExpense;
  }, []);

  const handleBlur = () => {
    if (livingValueRef.current === 'OWN') {
      setHomeStatusExpenses();
      expenseValueRef.current = undefined;
    }
    const errors = validator({ homeStatus, homeStatusExpense }, validations);
    setValidationErrors(errors);
  };

  const onChangeExpense = e => {
    const value = e.target.value;
    expenseValueRef.current = value;
    setHomeStatusExpenses(value);
  };

  const submit = e => {
    if (e) e.preventDefault();
    const errors = validator({ homeStatus, homeStatusExpense }, validations);

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
    } else {
      if (livingValueRef.current === 'OWN') {
        homeStatusExpense = undefined;
      }
      const type = isSecondary ? 'secondary' : 'primary';
      saveValues(
        {
          homeStatus: { homeStatus },
          homeStatusExpense: { homeStatusExpense },
        },
        type
      );
      nextLocation();
    }
  };

  const { title, header } = getTitleAndHeader();
  return (
    <Page
      name="livingSituation"
      title={title}
      header={header}
      goBack={previousLocation}
      submitHandler={submit}
      {...pageProps}
    >
      <LivingSituation
        onChange={onChange}
        homeStatusDefaultValue={homeStatus}
        homeStatusExpenseAmount={homeStatusExpense}
        validationErrors={validationErrors}
        handleBlur={handleBlur}
        onChangeExpense={onChangeExpense}
      />
    </Page>
  );
};

LivingPage.propTypes = {
  homeStatus: string,
  homeStatusExpense: oneOfType([number, string]),
  isJoint: bool.isRequired,
  saveValues: func.isRequired,
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
  firstName: string,
  isSecondary: bool.isRequired,
};

LivingPage.defaultProps = {
  homeStatus: '',
  homeStatusExpense: undefined,
  firstName: '',
};

export default LivingPage;

